module.exports = __webpack_public_path__ + "img/monthly_graphics.813e8d77.png";